import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import type { TQuizQuestion } from '@onesource/services';

interface ShortAnswerQuestionProps {
  question: TQuizQuestion;
  textAnswer: string;
  onTextChange: (text: string) => void;
  disabled?: boolean;
}

/**
 * Short Answer Question Component
 * Renders a text input field for free-form answers
 */
export const ShortAnswerQuestion = ({
  question: _question,
  textAnswer,
  onTextChange,
  disabled = false,
}: ShortAnswerQuestionProps) => {
  return (
    <Box
      sx={{
        p: 2,
        bgcolor: 'white',
        borderRadius: 2,
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
      }}
    >
      <TextField
        fullWidth
        multiline
        rows={4}
        value={textAnswer}
        onChange={e => onTextChange(e.target.value)}
        disabled={disabled}
        placeholder="Type your answer here..."
        variant="outlined"
        sx={{
          '& .MuiOutlinedInput-root': {
            fontSize: '1rem',
            bgcolor: '#fafafa',
            '& fieldset': {
              borderColor: '#ddd',
            },
            '&:hover fieldset': {
              borderColor: '#ff4d6d',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#ff4d6d',
            },
          },
        }}
      />
    </Box>
  );
};
